import { ProductSubtypeEnum } from '@app/models/enums/product-subtype.enum';
import { ProductTypeEnum } from '@app/models/enums/product-type.enum';
import { ApplicationInterface } from '@app/models/interfaces/application.interface';

const applicationsDropdown: ApplicationInterface[] = [
    {
        id: '',
        name: 'TaqMan Assays',
        searchType: '',
        disabled: false
    },
    {
        name: 'Assays',
        icon: `<svg viewBox="0 0 22 22">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.251 14.143L7.85601 10.761L11.691 6.914L15.085 10.309L11.251 14.143ZM6.61201 18.794C6.13401 19.259 5.53101 19.486 4.91501 19.486C4.29901 19.486 3.68301 19.259 3.21801 18.794C2.27501 17.851 2.27501 16.33 3.21801 15.4L6.34801 12.269L9.74201 15.651L6.61201 18.794ZM13.023 0L9.42801 3.595L10.446 4.614L9.91801 5.142L1.43301 13.615C-0.477994 15.538 -0.477994 18.656 1.43301 20.567C2.36301 21.497 3.59501 22 4.91501 22C6.22201 22 7.45401 21.497 8.38501 20.567L16.858 12.094L17.386 11.566L18.404 12.571L22 8.989L13.023 0Z"/>
            </svg>`,
        type: 'separator'
    },
    {
        id: 'ge',
        modulePath: 'gene-expression/assay/query',
        name: 'Gene Expression',
        productType: ProductTypeEnum.ge,
        productTypeURLParam: 'ge',
        productSubType: [ProductSubtypeEnum.ge],
        productSubTypeURLParam: 'ge',
        searchType: 'assay',
        disabled: false,
        unifiedCardProductId: 'TAQMAN_GE'
    },
    {
        id: 'mb-abr-assay',
        name: 'Microbe & ABR Detection',
        productType: ProductTypeEnum.microbe,
        productTypeURLParam: 'microbe',
        productSubType: [ProductSubtypeEnum.microbre_all],
        productSubTypeURLParam: 'microbre_all',
        showInUnifiedCard: true,
        unifiedCardProductSearch: 'microbe',
        searchType: 'assay'
    },
    {
        id: 'sg-assay',
        modulePath: 'snp/assay/query',
        name: 'SNP Genotyping',
        productType: ProductTypeEnum.snp,
        productTypeURLParam: 'gt',
        productSubType: [ProductSubtypeEnum.snp],
        productSubTypeURLParam: 'gt',
        searchType: 'assay',
        disabled: false,
        unifiedCardProductId: 'GT'
    },
    {
        id: 'cn-assay',
        modulePath: 'cnv/assay/query',
        name: 'Copy Number',
        productType: ProductTypeEnum.cnv,
        productTypeURLParam: 'cnv',
        productSubType: [ProductSubtypeEnum.cnv],
        productSubTypeURLParam: 'cnv',
        searchType: 'assay',
        disabled: false,
        unifiedCardProductId: 'CNV'
    },
    {
        id: 'mr-assay',
        name: 'miRNA',
        productType: ProductTypeEnum.microrna,
        productTypeURLParam: 'microrna',
        productSubType: [
            ProductSubtypeEnum.microrna_advanced,
            ProductSubtypeEnum.microrna_primary,
            ProductSubtypeEnum.microrna_classic
        ],
        productSubTypeURLParam: 'microrna_all',
        searchType: 'assay',
        showInUnifiedCard: true,
        unifiedCardProductSearch: 'microrna'
    },
    {
        id: 'md-assay',
        name: 'Mutation Detection',
        searchType: 'assay',
        disabled: false,
        showInUnifiedCard: true,
        unifiedCardProductSearch: 'mutation',
    },
    {
        name: 'Arrays',
        icon: `<svg viewBox="0 0 24 24">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.334 15.333C16.227 15.333 15.334 16.227 15.334 17.333C15.334 18.44 16.227 19.333 17.334 19.333C18.44 19.333 19.334 18.44 19.334 17.333C19.334 16.227 18.44 15.333 17.334 15.333ZM17.334 19.333C18.44 19.333 19.334 18.44 19.334 17.333C19.334 16.227 18.44 15.333 17.334 15.333C16.227 15.333 15.334 16.227 15.334 17.333C15.334 18.44 16.227 19.333 17.334 19.333ZM12 15.333C10.894 15.333 10 16.227 10 17.333C10 18.44 10.894 19.333 12 19.333C13.107 19.333 14 18.44 14 17.333C14 16.227 13.107 15.333 12 15.333ZM12 19.333C13.107 19.333 14 18.44 14 17.333C14 16.227 13.107 15.333 12 15.333C10.894 15.333 10 16.227 10 17.333C10 18.44 10.894 19.333 12 19.333ZM6.667 15.333C5.561 15.333 4.667 16.227 4.667 17.333C4.667 18.44 5.561 19.333 6.667 19.333C7.774 19.333 8.667 18.44 8.667 17.333C8.667 16.227 7.774 15.333 6.667 15.333ZM6.667 19.333C7.774 19.333 8.667 18.44 8.667 17.333C8.667 16.227 7.774 15.333 6.667 15.333C5.561 15.333 4.667 16.227 4.667 17.333C4.667 18.44 5.561 19.333 6.667 19.333ZM17.334 10.026C16.227 10.026 15.334 10.92 15.334 12.026C15.334 13.133 16.227 14.026 17.334 14.026C18.44 14.026 19.334 13.133 19.334 12.026C19.334 10.92 18.44 10.026 17.334 10.026ZM17.334 14.026C18.44 14.026 19.334 13.133 19.334 12.026C19.334 10.92 18.44 10.026 17.334 10.026C16.227 10.026 15.334 10.92 15.334 12.026C15.334 13.133 16.227 14.026 17.334 14.026ZM12 9.973C10.894 9.973 10 10.867 10 11.973C10 13.08 10.894 13.973 12 13.973C13.107 13.973 14 13.08 14 11.973C14 10.867 13.107 9.973 12 9.973ZM12 13.973C13.107 13.973 14 13.08 14 11.973C14 10.867 13.107 9.973 12 9.973C10.894 9.973 10 10.867 10 11.973C10 13.08 10.894 13.973 12 13.973ZM6.667 9.973C5.561 9.973 4.667 10.867 4.667 11.973C4.667 13.08 5.561 13.973 6.667 13.973C7.774 13.973 8.667 13.08 8.667 11.973C8.667 10.867 7.774 9.973 6.667 9.973ZM6.667 13.973C7.774 13.973 8.667 13.08 8.667 11.973C8.667 10.867 7.774 9.973 6.667 9.973C5.561 9.973 4.667 10.867 4.667 11.973C4.667 13.08 5.561 13.973 6.667 13.973ZM17.334 8.666C18.44 8.666 19.334 7.773 19.334 6.666C19.334 5.56 18.44 4.666 17.334 4.666C16.227 4.666 15.334 5.56 15.334 6.666C15.334 7.773 16.227 8.666 17.334 8.666ZM17.334 8.666C18.44 8.666 19.334 7.773 19.334 6.666C19.334 5.56 18.44 4.666 17.334 4.666C16.227 4.666 15.334 5.56 15.334 6.666C15.334 7.773 16.227 8.666 17.334 8.666ZM12 4.666C10.894 4.666 10 5.56 10 6.666C10 7.773 10.894 8.666 12 8.666C13.107 8.666 14 7.773 14 6.666C14 5.56 13.107 4.666 12 4.666ZM12 8.666C13.107 8.666 14 7.773 14 6.666C14 5.56 13.107 4.666 12 4.666C10.894 4.666 10 5.56 10 6.666C10 7.773 10.894 8.666 12 8.666ZM6.667 4.666C5.561 4.666 4.667 5.56 4.667 6.666C4.667 7.773 5.561 8.666 6.667 8.666C7.774 8.666 8.667 7.773 8.667 6.666C8.667 5.56 7.774 4.666 6.667 4.666ZM6.667 8.666C7.774 8.666 8.667 7.773 8.667 6.666C8.667 5.56 7.774 4.666 6.667 4.666C5.561 4.666 4.667 5.56 4.667 6.666C4.667 7.773 5.561 8.666 6.667 8.666ZM2.667 21.333H21.334V2.666H2.667V21.333ZM22.201 0H1.8C0.814 0 0 0.813 0 1.8V22.2C0 23.2 0.814 24 1.8 24H22.201C23.201 24 24 23.2 24 22.2V1.8C24 0.813 23.201 0 22.201 0ZM17.334 15.333C16.227 15.333 15.334 16.227 15.334 17.333C15.334 18.44 16.227 19.333 17.334 19.333C18.44 19.333 19.334 18.44 19.334 17.333C19.334 16.227 18.44 15.333 17.334 15.333ZM12 15.333C10.894 15.333 10 16.227 10 17.333C10 18.44 10.894 19.333 12 19.333C13.107 19.333 14 18.44 14 17.333C14 16.227 13.107 15.333 12 15.333ZM6.667 15.333C5.561 15.333 4.667 16.227 4.667 17.333C4.667 18.44 5.561 19.333 6.667 19.333C7.774 19.333 8.667 18.44 8.667 17.333C8.667 16.227 7.774 15.333 6.667 15.333ZM17.334 10.026C16.227 10.026 15.334 10.92 15.334 12.026C15.334 13.133 16.227 14.026 17.334 14.026C18.44 14.026 19.334 13.133 19.334 12.026C19.334 10.92 18.44 10.026 17.334 10.026ZM12 9.973C10.894 9.973 10 10.867 10 11.973C10 13.08 10.894 13.973 12 13.973C13.107 13.973 14 13.08 14 11.973C14 10.867 13.107 9.973 12 9.973ZM6.667 9.973C5.561 9.973 4.667 10.867 4.667 11.973C4.667 13.08 5.561 13.973 6.667 13.973C7.774 13.973 8.667 13.08 8.667 11.973C8.667 10.867 7.774 9.973 6.667 9.973ZM17.334 4.666C16.227 4.666 15.334 5.56 15.334 6.666C15.334 7.773 16.227 8.666 17.334 8.666C18.44 8.666 19.334 7.773 19.334 6.666C19.334 5.56 18.44 4.666 17.334 4.666ZM12 4.666C10.894 4.666 10 5.56 10 6.666C10 7.773 10.894 8.666 12 8.666C13.107 8.666 14 7.773 14 6.666C14 5.56 13.107 4.666 12 4.666ZM6.667 4.666C5.561 4.666 4.667 5.56 4.667 6.666C4.667 7.773 5.561 8.666 6.667 8.666C7.774 8.666 8.667 7.773 8.667 6.666C8.667 5.56 7.774 4.666 6.667 4.666Z"/>
            </svg>`,
        type: 'separator'
    },
    {
        id: 'gx',
        modulePath: 'gene-expression/array/query',
        name: 'Gene Expression',
        searchType: 'array',
        productType: ProductTypeEnum.gx,
        productTypeURLParam: 'gx',
        productSubType: [ProductSubtypeEnum.gx],
        productSubTypeURLParam: 'gx',
        disabled: false,
        unifiedCardProductId: 'ARRAY_GX'
    },
    {
        id: 'mr-array',
        modulePath: 'microrna/array',
        name: 'miRNA',
        productType: ProductTypeEnum.microrna,
        productTypeURLParam: 'mirna',
        productSubType: [ProductSubtypeEnum.microrna_array],
        searchType: 'array',
        disabled: false,
        unifiedCardProductId: 'ARRAY_MIRNA'
    }
];

export { applicationsDropdown };
